module.exports = __webpack_public_path__ + "static/media/product_welcome.91294ec4.png";